module.exports = __webpack_public_path__ + "img/tu_file_xls.764957f3.svg";